import { memo } from 'react'
import { Typography } from '@mui/material'
import FlagList from '../flags/FlagList'
import useFullFlagListData from '../flags/useFullFlagListData'

type FlagsCardContentProps = {
  isLoading?: boolean
}
function FlagsCardContent({ isLoading }: FlagsCardContentProps) {
  const { totalLength, ...rest } = useFullFlagListData()
  return (
    <>
      {totalLength > 0 ? (
        <FlagList isLoading={isLoading} {...rest} />
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
          No flags
        </Typography>
      )}
    </>
  )
}

export default memo(FlagsCardContent)
